// extracted by mini-css-extract-plugin
module.exports = {"page":"Admin_page__2WB35","addItem":"Admin_addItem__1wqjl","items":"Admin_items__1YLkk","orderItem":"Admin_orderItem__PxQFG","image":"Admin_image__x6Vr7"};